export default "__VITE_ASSET__C3Esipy7__"